"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const SearchBar_1 = __importDefault(require("components/shared/SearchBar"));
const AdvanceFilter_1 = require("src/components/filter/AdvanceFilter");
const useFilter_1 = __importDefault(require("src/hooks/global-state/useFilter"));
const FilterSearch = () => {
    const [search, setSearch] = (0, react_1.useState)('');
    const { id } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const firstRender = (0, react_1.useRef)(true);
    const filter = (0, useFilter_1.default)((state) => state.filter);
    const setFilter = (0, useFilter_1.default)((state) => state.setFilter);
    const handleChangeSearch = (search) => {
        const newFilter = (0, cloneDeep_1.default)(filter[id]);
        newFilter.q = search;
        setFilter(id, newFilter);
    };
    const debounceFn = (0, react_1.useCallback)((0, debounce_1.default)(() => {
        handleChangeSearch(search);
    }, 1000), [search]);
    (0, react_1.useEffect)(() => {
        if (firstRender.current) {
            firstRender.current = false;
        }
        else {
            debounceFn();
        }
        return debounceFn.cancel;
    }, [search, debounceFn]);
    return (react_1.default.createElement("div", { className: "flex grow" },
        react_1.default.createElement(SearchBar_1.default, { fullWidth: true, onChange: (e) => setSearch(e.target.value), dataCy: "advance-filter-search" })));
};
exports.default = FilterSearch;
